<template>
  <div id="app">
    <div id="main">
      <LayoutNavbar/>

      <div id="content">
        <div class="container">
          <div class="row justify-content-md-center">
            <div class="col-md-12">
              <div class="row has-sidebar">
                <div class="col-md-4 col-lg-3 col-xl-3 col-sidebar">
                  <LayoutSidenav/>
                </div>

                <div class="col-md-8 col-lg-9 col-xl-9">
                  <router-view/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button class="btn btn-primary btn-circle" id="to-top">
        <i class="fa fa-angle-up"></i>
      </button>
      <LayoutFooter/>
    </div>
  </div>
</template>

<script>
import LayoutNavbar from './LayoutNavbar.vue'
import LayoutFooter from './LayoutFooter.vue'
import LayoutSidenav from './LayoutSidenav.vue'

export default {
  name: 'LayoutAdmin',
  components: {
    LayoutNavbar,
    LayoutFooter,
    LayoutSidenav
  }
}
</script>
